<template>
  <transition name="fade">
    <div v-if="show" class="w-75 row col-8 mx-auto bg-light rounded p-3 mt-5">
      <div class="col-12">
        <p class="fs-5">
          Il n’est pas nécessaire de compléter le formulaire d’autodiagnostic
          municipal en une seule fois. Pour sauvegarder votre progression et vos
          résultats, vous pouvez :
        </p>
        <ul class="fs-5">
          <li class="my-2">
            <strong>créer un compte</strong>, la création d’un compte vous
            permet de retrouver plus facilement vos résultats. Elle permet
            également d’ajouter des notes personnelles.
            <br />
            <em>
              Si vous possédez déjà un compte ROBVQ, il n’est pas nécessaire
              d’en créer un nouveau.
            </em>
          </li>

          <li class="my-2">
            soit <strong>conserver le code unique</strong> à 6 caractères
            (jeton) généré lors de votre première connexion.
          </li>
        </ul>
      </div>
      <div class="col-12 d-flex-column-center mx-auto" style="width: 28em">
        <a :class="btnCssClass" :href="loginUrl">
          Se connecter
        </a>
        <a :class="btnCssClass" :href="registerUrl">
          Créer un compte
        </a>
        <AppLink :class="btnCssClass" :href="$route('survey.start')">
          Commencer sans créer de compte
        </AppLink>
      </div>
    </div>
  </transition>
</template>

<script>
import AuthMixin from '../mixins/AuthMixin'

export default {
  mixins: [AuthMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnCssClass: 'btn btn-primary my-2 w-100',
    }
  },
}
</script>
<style scoped>
.fade-enter-active {
  transition: opacity 0.5s ease-in-out;
}
.fade-leave-active {
  transition: opacity 0.25s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
